import { currentDashboard } from '../../utils/roleWorkspace';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { resolveNotificationTarget } from '../../utils/notificationDeepLink';

// Decode the base64url-encoded notification descriptor that the backend embeds
// in web-push deep links (fcmOptions.link = `${origin}/n/go?nd=<base64url>`).
function decodeNotificationDescriptor(nd) {
  if (!nd) return null;
  try {
    let base64 = String(nd).replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) base64 += '=';
    const binary = atob(base64);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes));
  } catch (error) {
    return null;
  }
}

/**
 * Landing route for web-push notification clicks. It resolves the structured
 * notification descriptor into the correct in-app destination and redirects.
 * Reachable at /n/go regardless of auth state.
 */
function NotificationRedirect() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      // Preserve the intended destination so we can honor it after login.
      try {
        sessionStorage.setItem('post_login_redirect', `/n/go?${searchParams.toString()}`);
      } catch (error) {
        // ignore storage failures
      }
      navigate('/auth/login', { replace: true });
      return;
    }

    const role = currentDashboard() === '/user/dashboard' ? 'trainee' : localStorage.getItem('role');
    const descriptor = decodeNotificationDescriptor(searchParams.get('nd'));

    let target = null;
    if (descriptor) {
      target = resolveNotificationTarget(
        { event: descriptor.event, content_json: { data: descriptor.data || {} } },
        role
      );
    }

    if (!target) {
      const fallback = searchParams.get('to');
      target = fallback || (role === 'trainee' ? '/user/dashboard' : '/admin/dashboard');
    }

    navigate(target, { replace: true });
  }, [navigate, searchParams]);

  return null;
}

export default NotificationRedirect;
